import axios from 'axios';
import { mainUrl } from './constant'

const axiosClient = axios.create({
  baseURL: mainUrl,
  withCredentials: true, // Add this line to send cookies with requests
});

// Remove the interceptor logic that handles tokens from localStorage
// The browser will now automatically handle sending HttpOnly cookies

// Example: Remove or comment out the request interceptor that adds the Authorization header
/*
axiosClient.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("accessToken"); // REMOVE THIS
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
*/

// Example: Remove or comment out the response interceptor that handles token refresh using localStorage
/*
axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    // Check for token expiration error (e.g., 401 Unauthorized)
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem("refreshToken"); // REMOVE THIS
        if (!refreshToken) throw new Error('No refresh token');

        const { data } = await axios.post(`${config.apiUrl}/auth/refresh-token`, {
          refreshToken,
        }, { withCredentials: true }); // Ensure refresh request also sends cookies if needed

        const { accessToken, refreshToken: newRefreshToken } = data;

        // REMOVE localStorage updates
        // localStorage.setItem("accessToken", accessToken);
        // localStorage.setItem("refreshToken", newRefreshToken);

        // Update the Authorization header for the original request
        // This part might be unnecessary if cookies are handled automatically
        // originalRequest.headers.Authorization = `Bearer ${accessToken}`;

        // Retry the original request
        return axiosClient(originalRequest);
      } catch (refreshError) {
        // Handle refresh token failure (e.g., redirect to login)
        console.error('Unable to refresh token:', refreshError);
        // Optionally clear context/state and redirect
        // logout(); // Assuming you have a logout function
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);
*/

export default axiosClient;